import { TimelineImageData } from "../../mock/timeline";
import { Box } from "../Box";
import { TimelineImage } from "./TimlineImage";
import { TimelineImageLabel } from "./TimlineImageLabel";

interface TimelineItemImageProps {
  data: TimelineImageData;
}

export const TimelineItemImage: React.FC<TimelineItemImageProps> = ({
  data,
}) => {
  return (
    <Box>
      <TimelineImage
        imageConfig={data.image}
        labelPosition={data.labelPosition}
      >
        <TimelineImageLabel
          year={data.yearText}
          label={data.labelText}
          align={data.labelAlignment}
        />
      </TimelineImage>
    </Box>
  );
};
